import { FC } from 'react'
import { Box, Button, Link, Modal, Typography } from '@mui/material'
import { useIntl } from 'react-intl'

const EBOK_URL = 'https://e-bok.vantagerent.pl/pl/login/'

interface VantageMigrationNoticeDialogProps {
  isOpen: boolean
  onClose: () => void
}

const VantageMigrationNoticeDialog: FC<VantageMigrationNoticeDialogProps> = ({
  isOpen,
  onClose
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby='vantage-migration-notice-title'
      aria-describedby='vantage-migration-notice-description'>
      <Box
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 520,
          width: '90%',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          overflow: 'hidden'
        }}>
        <Box
          sx={{
            maxHeight: '90vh',
            overflowY: 'auto',
            p: 4,
            pr: 3,
            scrollbarWidth: 'thin',
            scrollbarColor: (theme) => `${theme.palette.grey[400]} transparent`,
            '&::-webkit-scrollbar': {
              width: 6
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
              marginTop: '8px',
              marginBottom: '8px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey.400',
              borderRadius: 3
            }
          }}>
        <Typography id='vantage-migration-notice-title' variant='h6' component='h2' sx={{ mb: 2 }}>
          {formatMessage({
            id: 'vantageMigration.greeting',
            defaultMessage: 'Drogi Mieszkańcu,'
          })}
        </Typography>

        <Typography id='vantage-migration-notice-description' sx={{ mb: 2 }}>
          {formatMessage({
            id: 'vantageMigration.intro',
            defaultMessage:
              'Vantage Rent jest obecnie podmiotem obsługującym Twoją umowę. Strefa Klienta Resi4Rent pozostaje włączona dla Ciebie jedynie w trybie do odczytu.'
          })}
        </Typography>

        <Typography sx={{ mb: 2 }}>
          {formatMessage({
            id: 'vantageMigration.ebokBefore',
            defaultMessage:
              'Zainstaluj nową Strefę Klienta Vantage Rent (eBOK), postępując zgodnie z instrukcją:'
          })}{' '}
          <Link href={EBOK_URL} target='_blank' rel='noopener noreferrer'>
            {EBOK_URL}
          </Link>{' '}
          {formatMessage({
            id: 'vantageMigration.ebokAfter',
            defaultMessage: 'Będąc na stronie, kliknij: „Zapomniałeś hasła?”'
          })}
        </Typography>

        <Typography sx={{ mb: 1 }}>
          {formatMessage({
            id: 'vantageMigration.contactHeader',
            defaultMessage:
              'W razie dalszych pytań lub problemów skontaktuj się pod numer telefonu właściwym dla nieruchomości, w której mieszkasz:'
          })}
        </Typography>

        <Typography sx={{ mb: 2, whiteSpace: 'pre-line' }}>
          {formatMessage({
            id: 'vantageMigration.contacts',
            defaultMessage:
              '• Dla mieszkańców lokalizacji Poznań Brneńska:\n61 261 25 22\n• Dla mieszkańców lokalizacji Poznań Szczepanowskiego:\n61 261 25 23\n• Dla mieszkańców lokalizacji Łódź Wodna:\n42 671 65 94\n• Dla mieszkańców lokalizacji Łódź Kilińskiego:\n42 671 65 93\n• Dla mieszkańców lokalizacji Wrocław Park Zachodni:\n71 786 0002\n• Dla mieszkańców lokalizacji Wrocław Grabiszyńska:\n71 786 0005\n• Dla mieszkańców lokalizacji Wrocław Rychtalska:\n71 786 0004\n• Dla mieszkańców lokalizacji Wrocław Jaworska:\n71 786 0003'
          })}
        </Typography>

        <Typography sx={{ mb: 3, whiteSpace: 'pre-line' }}>
          {formatMessage({
            id: 'vantageMigration.closing',
            defaultMessage: 'Pozdrawiamy\nZespół Resi4Rent'
          })}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
          <Button fullWidth variant='contained' color='primary' onClick={onClose}>
            {formatMessage({
              id: 'vantageMigration.understand',
              defaultMessage: 'Rozumiem'
            })}
          </Button>
          <Button fullWidth variant='outlined' color='primary' onClick={onClose}>
            {formatMessage({
              id: 'vantageMigration.later',
              defaultMessage: 'Później'
            })}
          </Button>
        </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default VantageMigrationNoticeDialog
